import {
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import { Dividend, DividendForm } from "./dividendDomain";
import { PaymentMethods, Resolution } from "@/types/Transactions";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<Dividend>,
  data?: Dividend,
): DividendForm {
  return new DividendForm(dispatch, context, data);
}

export function applyForm(form: DividendForm): Dividend {
  return {
    type: DecisionType.dividend,
    isExtraordinaryDividend: form.isExtraordinaryDividend.value ?? false,
    extraordinaryDividendDate: form.extraordinaryDividendDate.validatedValue,
    isBalanceSheetApproved: form.isBalanceSheetApproved?.value,
    extraordinaryDividendGmApprovalDate: form.extraordinaryDividendGmApprovalDate.validatedValue,
    extraordinaryDividendRevised: form.extraordinaryDividendRevised.value,
    usePowerOfAttorney: form.usePowerOfAttorney.value,
    powerOfAttorneyDate: form.powerOfAttorneyDate.validatedValue,
    resolutionBy: form.usePowerOfAttorney.value ? Resolution.POA : Resolution.GENERAL_MEETING,
    isDividendEvenlyDivided: form.isDividendEvenlyDivided.value ?? true,
    shareholderEvenDividends: form.isDividendEvenlyDivided.value
      ? form.shareholderEvenDividends.map((s) => ({
          id: s.id,
          name: s.name,
          value: s.value.parsedValue,
          isValueTotal:
            s.dividendType.value === PaymentMethods.TOTAL_INCL ||
            s.dividendType.value === PaymentMethods.TOTAL_EX,
          isCompanySharesExcluded: s.dividendType.value === PaymentMethods.TOTAL_EX,
        }))
      : [],
    shareholderUnevenDividends: !form.isDividendEvenlyDivided.value
      ? form.shareholderUnevenDividends.map((d) => ({
          id: d.id,
          name: d.name,
          shareType: d.shareType.map((s) => ({
            id: s.id,
            name: s.name,
            value: s.value.parsedValue ?? 0,
          })),
        }))
      : [],
    dividendRepaymentOfCapital: form.dividendRepaymentOfCapital.value ?? false,
    isDividendPeriodNormal: form.isDividendPeriodNormal.value ?? true,
    dividendDate: form.dividendDate.toISOString(),
  };
}

export function validate(form: DividendForm) {
  return form.validate();
}

export function isValid(form: DividendForm) {
  return form.isValid;
}

export const dividendHandler: DecisionTypeHandler<DecisionType.dividend, Dividend, DividendForm> = {
  type: DecisionType.dividend,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
